import { createAsyncThunk } from "@reduxjs/toolkit";
import newsApi from 'api/newsApi';
import { formatQueryParams } from "helpers/format";

export const getListNews = createAsyncThunk("List News", async (params: any = {}) => {
  try {
    const response = await newsApi.aiNews(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getGenerateNews = createAsyncThunk("Generate News", async (params: any = {}) => {
  try {
    const response = await newsApi.generateNews(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getNewsKeywords = createAsyncThunk("News Keywords", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsKeywords(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getNewsBoostingLogs = createAsyncThunk("List Boosting News Logs", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsBoostingLogs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getNewsV2s = createAsyncThunk("List News V2s", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsV2s(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getNewsV2Logs = createAsyncThunk("List News V2 Logs", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsV2Logs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getNewsTravels = createAsyncThunk("List News Travel", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsTravels(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getPlaceTravels = createAsyncThunk("List Place Travel", async (params: any = {}) => {
  try {
    const response = await newsApi.getPlaceTravels(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getNewsTravelLogs = createAsyncThunk("List News Travel Logs", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsTravelLogs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getPlaceWeathers = createAsyncThunk("List Place Weather", async (params: any = {}) => {
  try {
    const response = await newsApi.getPlaceWeathers(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getNewsWeathers = createAsyncThunk("List News Weather", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsWeathers(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getNewsWeatherLogs = createAsyncThunk("List News Weather Logs", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsWeatherLogs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getNewsWeatherWarnings = createAsyncThunk("List News Weather Warnings", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsWeatherWarnings(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getNewsWeatherWarningLogs = createAsyncThunk("List News Weather Warning Logs", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsWeatherWarningLogs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getNewsStocks = createAsyncThunk("List News Stocks", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsStocks(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getNewsStockLogs = createAsyncThunk("List News Stock Logs", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsStockLogs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getNewsStockSchedules = createAsyncThunk("List News Stock Schedules", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsStockSchedules(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getTossStocks = createAsyncThunk("List Toss Stocks", async (params: any = {}) => {
  try {
    const response = await newsApi.getTossStocks(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const getNewsTossStocks = createAsyncThunk("List News Toss Stocks", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsTossStocks(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getNewsTossStockLogs = createAsyncThunk("List News Toss Stock Logs", async (params: any = {}) => {
  try {
    const response = await newsApi.getNewsTossStockLogs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getAINewsByNormal = async (params: any = {}) => {
  try {
    const response = await newsApi.aiNews(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const getGovernmentNewsByNormal = async (params: any = {}) => {
  try {
    const response = await newsApi.governmentNews(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const getNews = async (id: string | number, params: any = {}) => {
  try {
    const response = await newsApi.news(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const putNews = async (id: number | string, data: any = {}) => {
  try {
    const response = await newsApi.putNews(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getChartRankingKeywordNews = async (params: any = {}) => {
  try {
    const response = await newsApi.getChartRankingKeywordNews(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getChartDailySearchVolumeRankingKeywordNews = async (params: any = {}) => {
  try {
    const response = await newsApi.getChartDailySearchVolumeRankingKeywordNews(params)
    return response;
  } catch (error) {
    return error;
  }
};



export const putKeywordNews = async (id: number | string, data: any = {}) => {
  try {
    const response = await newsApi.putKeywordNews(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putCategoryNews = async (id: number | string, data: any = {}) => {
  try {
    const response = await newsApi.putCategoryNews(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putTagNews = async (id: number | string, data: any = {}) => {
  try {
    const response = await newsApi.putTagNews(id, data);
    return response;
  } catch (error) {
    return error;
  }
};


export const postPublishUrlNews = async (id: number | string, data: any = {}) => {
  try {
    const response = await newsApi.postPublishUrlNews(id, data);
    return response;
  } catch (error) {
    return error;
  }
};


export const downloadNews = async (id: string | number, params: any = {}) => {
  try {
    const response = await newsApi.downloadNews(id, formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const downloadExcelNews = async (params: any = {}) => {
  try {
    const response = await newsApi.downloadExcelNews(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
};

export const importMediaMewsByExcel = async (data: any = {}) => {
  try {
    const response = await newsApi.importMediaMewsByExcel(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const postNewsTracking = async (data: any = {}) => {
  try {
    const response = await newsApi.postNewsTracking(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const publishNews = async (id: string | number, params: any = {}) => {
  try {
    const response = await newsApi.publishNews(id, formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};


export const unPublishNews = async (id: string | number, params: any = {}) => {
  try {
    const response = await newsApi.unPublishNews(id, params)
    return response;
  } catch (error) {
    return error;
  }
};


export const cancelMyNews = async (id: string | number, params: any = {}) => {
  try {
    const response = await newsApi.cancelMyNews(id, formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};


export const deleteNewsMulti = async (data: any = {}) => {
  try {
    const response = await newsApi.deleteNewsMulti(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getKeywordGenerateNews = async (id: string | number, params: any = {}) => {
  try {
    const response = await newsApi.keywordGenerateNews(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postKeywordGenerateNews = async (data: any = {}) => {
  try {
    const response = await newsApi.postKeywordGenerateNews(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putKeywordGenerateNews = async (id: number | string, data: any = {}) => {
  try {
    const response = await newsApi.putKeywordGenerateNews(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putKeywordReGenerateNews = async (id: number | string, data: any = {}) => {
  try {
    const response = await newsApi.putKeywordReGenerateNews(id, data);
    return response;
  } catch (error) {
    return error;
  }
};


export const deleteKeywordGenerateNews = async (data: any = {}) => {
  try {
    const response = await newsApi.deleteKeywordGenerateNews(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const deleteGenerateNewsMulti = async (data: any = {}) => {
  try {
    const response = await newsApi.deleteGenerateNewsMulti(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const postKeywordGenerateNewsV2 = async (data: any = {}) => {
  try {
    const response = await newsApi.postKeywordGenerateNewsV2(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const getDetailGenerateNewsV2 = async (id: string | number) => {
  try {
    const response = await newsApi.getDetailGenerateNewsV2(id);
    return response;
  } catch (error) {
    return error;
  }
};

export const getAllReporters = async (params: any = {}) => {
  try {
    const response = await newsApi.allReporters(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getAllPartners = async (params: any = {}) => {
  try {
    const response = await newsApi.allPartners(params)
    return response;
  } catch (error) {
    return error;
  }
};



export const getAllMediaAdsHub = async (params: any = {}) => {
  try {
    const response = await newsApi.getAllMediaAdsHub(params)
    return response;
  } catch (error) {
    return error;
  }
};



export const getGenerateBoostingNews = async (params: any = {}) => {
  try {
    const response = await newsApi.getGenerateBoostingNews(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postGenerateBoostingNews = async (data: any = {}) => {
  try {
    const response = await newsApi.postGenerateBoostingNews(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const putGenerateBoostingNews = async (id: string | number, data: any = {}) => {
  try {
    const response = await newsApi.putGenerateBoostingNews(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getTemplateSampleBoostingNewsExcel = async (params: any = {}) => {
  try {
    const response = await newsApi.getTemplateSampleBoostingNewsExcel(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const importGenerateBoostingNewsByExcel = async (data: any = {}) => {
  try {
    const response = await newsApi.importGenerateBoostingNewsByExcel(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const postGenerateBoostingNewsV2 = async (data: any = {}) => {
  try {
    const response = await newsApi.postGenerateBoostingNewsV2(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const importGenerateBoostingNewsV2ByExcel = async (data: any = {}) => {
  try {
    const response = await newsApi.importGenerateBoostingNewsV2ByExcel(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getTemplateSampleNewsV2Excel = async (params: any = {}) => {
  try {
    const response = await newsApi.getTemplateSampleNewsV2Excel(params)
    return response;
  } catch (error) {
    return error;
  }
};


export const deleteMultiNewsV2 = async (data: any = {}) => {
  try {
    const response = await newsApi.deleteMultiNewsV2(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getTemplateSampleNewsExcel = async (params: any = {}) => {
  try {
    const response = await newsApi.getTemplateSampleNewsExcel(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postReCreateVoteKeywordNews = async (id: string | number, data: any = {}) => {
  try {
    const response = await newsApi.postReCreateVoteKeywordNews(id, data);
    return response;
  } catch (error) {
    return error;
  }
};



// Travel

export const getAllCategoryTravel = async (params: any = {}) => {
  try {
    const response = await newsApi.allCategoryTravel(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getAllPlaceTravel = async (params: any = {}) => {
  try {
    const response = await newsApi.allPlaceTravel(params);
    return response;
  } catch (error) {
    return error;
  }
};

export const getAllTagTravel = async (params: any = {}) => {
  try {
    const response = await newsApi.allTagTravel(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postGenerateNewsTravel = async (data: any = {}) => {
  try {
    const response = await newsApi.postGenerateNewsTravel(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const getDetailGenerateNewsTravel = async (id: string | number) => {
  try {
    const response = await newsApi.getDetailGenerateNewsTravel(id);
    return response;
  } catch (error) {
    return error;
  }
};

export const postSimulatorGenerateNewsTravel = async (data: any = {}) => {
  try {
    const response = await newsApi.postSimulatorGenerateNewsTravel(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getDetailSimulatorGenerateNewsTravel = async (id: string | number) => {
  try {
    const response = await newsApi.getDetailSimulatorGenerateNewsTravel(id);
    return response;
  } catch (error) {
    return error;
  }
};

export const importGenerateTravelNewsByExcel = async (data: any = {}) => {
  try {
    const response = await newsApi.importGenerateTravelNewsByExcel(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getTemplateSampleTravelNewsExcel = async (params: any = {}) => {
  try {
    const response = await newsApi.getTemplateSampleTravelNewsExcel(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getSummarySelectedPlacesByCategory = async (params: any = {}) => {
  try {
    const response = await newsApi.getSummarySelectedPlacesByCategory(params)
    return response;
  } catch (error) {
    return error;
  }
};


// Weather
export const getAllPlaceWeathers = async (params: any = {}) => {
  try {
    const response = await newsApi.allPlaceWeathers(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getInfoWeather = async (params: any = {}) => {
  try {
    const response = await newsApi.getInfoWeather(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postGenerateWeatherNews = async (data: any = {}) => {
  try {
    const response = await newsApi.postGenerateWeatherNews(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getInfoWeatherWarning = async (params: any = {}) => {
  try {
    const response = await newsApi.getInfoWeatherWarning(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const importGenerateWeatherNewsByExcel = async (data: any = {}) => {
  try {
    const response = await newsApi.importGenerateWeatherNewsByExcel(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const getTemplateSampleWeatherNewsExcel = async (params: any = {}) => {
  try {
    const response = await newsApi.getTemplateSampleWeatherNewsExcel(params)
    return response;
  } catch (error) {
    return error;
  }
};


export const postSimulatorGenerateNewsWeather = async (data: any = {}) => {
  try {
    const response = await newsApi.postSimulatorGenerateNewsWeather(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const postSimulatorGenerateNewsWeatherWarning = async (data: any = {}) => {
  try {
    const response = await newsApi.postSimulatorGenerateNewsWeatherWarning(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getDetailSimulatorGenerateNewsWeather = async (id: string | number) => {
  try {
    const response = await newsApi.getDetailSimulatorGenerateNewsWeather(id);
    return response;
  } catch (error) {
    return error;
  }
};


export const postGenerateWeatherWarningNews = async (data: any = {}) => {
  try {
    const response = await newsApi.postGenerateWeatherWarningNews(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const importGenerateWeatherWarningNewsByExcel = async (data: any = {}) => {
  try {
    const response = await newsApi.importGenerateWeatherWarningNewsByExcel(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getTemplateSampleWeatherWarningNewsExcel = async (params: any = {}) => {
  try {
    const response = await newsApi.getTemplateSampleWeatherWarningNewsExcel(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getDetailSimulatorGenerateNewsWeatherWarning = async (id: string | number) => {
  try {
    const response = await newsApi.getDetailSimulatorGenerateNewsWeatherWarning(id);
    return response;
  } catch (error) {
    return error;
  }
};



// Stock
export const getTemplateSampleNewsStockExcel = async (params: any = {}) => {
  try {
    const response = await newsApi.getTemplateSampleNewsStockExcel(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const importGenerateNewsStockByExcel = async (data: any = {}) => {
  try {
    const response = await newsApi.importGenerateNewsStockByExcel(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const downloadImageNewsStockBulk = async (params: any = {}) => {
  try {
    const response = await newsApi.downloadImageNewsStockBulk(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
};

export const postSimulatorGenerateNewsStock = async (data: any = {}) => {
  try {
    const response = await newsApi.postSimulatorGenerateNewsStock(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const getDetailSimulatorGenerateNewsStock = async (id: string | number) => {
  try {
    const response = await newsApi.getDetailSimulatorGenerateNewsStock(id);
    return response;
  } catch (error) {
    return error;
  }
};


export const cancelNewsStockSchedule = async (id: string | number) => {
  try {
    const response = await newsApi.cancelNewsStockSchedule(id);
    return response;
  } catch (error) {
    return error;
  }
};


export const postGenerateNewsStockByToss = async (data: any = {}) => {
  try {
    const dataCustom = {
      start_rank: data?.start_rank !== "" ? Number(data?.start_rank) : null,
      end_rank: data?.end_rank !== "" ? Number(data?.end_rank) : null,
      min_pct: data?.min_pct !== "" ? Number(data?.min_pct) : null,
      max_pct: data?.max_pct !== "" ? Number(data?.max_pct) : null,
      min_price: data?.min_price !== "" ? Number(data?.min_price) : null,
      up_check: data?.up_check !== "" ? Number(data?.up_check) : null,
      down_check: data?.down_check !== "" ? Number(data?.down_check) : null,
      only_domestic: data?.only_domestic !== "" ? Number(data?.only_domestic) : null,
      only_foreign: data?.only_foreign !== "" ? Number(data?.only_foreign) : null,
    };
    const response = await newsApi.postGenerateNewsStockByToss(dataCustom);
    return response;
  } catch (error) {
    return error;
  }
};